/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GCPPubSubConfig,
  GCPPubSubConfig$inboundSchema,
  GCPPubSubConfig$Outbound,
  GCPPubSubConfig$outboundSchema,
} from "./gcppubsubconfig.js";
import {
  GCPPubSubCredentials,
  GCPPubSubCredentials$inboundSchema,
  GCPPubSubCredentials$Outbound,
  GCPPubSubCredentials$outboundSchema,
} from "./gcppubsubcredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationCreateGCPPubSub = {
  /**
   * Optional user-provided ID. A UUID will be generated if empty.
   */
  id?: string | undefined;
  /**
   * Type of the destination. Must be 'gcp_pubsub'.
   */
  type: "gcp_pubsub";
  /**
   * "*" or an array of enabled topics.
   */
  topics: Topics;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config: GCPPubSubConfig;
  credentials: GCPPubSubCredentials;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateGCPPubSub$inboundSchema: z.ZodType<
  DestinationCreateGCPPubSub,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string().optional(),
  type: z.literal("gcp_pubsub"),
  topics: Topics$inboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: GCPPubSubConfig$inboundSchema,
  credentials: GCPPubSubCredentials$inboundSchema,
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationCreateGCPPubSub$Outbound = {
  id?: string | undefined;
  type: "gcp_pubsub";
  topics: Topics$Outbound;
  filter?: { [k: string]: any } | null | undefined;
  config: GCPPubSubConfig$Outbound;
  credentials: GCPPubSubCredentials$Outbound;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateGCPPubSub$outboundSchema: z.ZodType<
  DestinationCreateGCPPubSub$Outbound,
  z.ZodTypeDef,
  DestinationCreateGCPPubSub
> = z.object({
  id: z.string().optional(),
  type: z.literal("gcp_pubsub"),
  topics: Topics$outboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: GCPPubSubConfig$outboundSchema,
  credentials: GCPPubSubCredentials$outboundSchema,
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationCreateGCPPubSubToJSON(
  destinationCreateGCPPubSub: DestinationCreateGCPPubSub,
): string {
  return JSON.stringify(
    DestinationCreateGCPPubSub$outboundSchema.parse(destinationCreateGCPPubSub),
  );
}
export function destinationCreateGCPPubSubFromJSON(
  jsonString: string,
): SafeParseResult<DestinationCreateGCPPubSub, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationCreateGCPPubSub$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationCreateGCPPubSub' from JSON`,
  );
}
